import script from "./period-selection-date-type-dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./period-selection-date-type-dropdown.vue?vue&type=script&lang=ts&setup=true"

import "./period-selection-date-type-dropdown.vue?vue&type=style&index=0&id=73576700&lang=css"

const __exports__ = script;

export default __exports__